import React from "react";
import { PictureCover, PictureImage } from "globalStyles/Containers";
import { CornerIcon } from "../PicturesLoadedStyled";
import StatusIcon from "components/Icons/StatusIcon";

const ImageBox = ({ src, name, status, historic, onPictureClickHandler }) => {
  const onClick = () => onPictureClickHandler({ name, src, status });
  return (
    <PictureCover key={src} data-testid="image-loaded" onClick={onClick}>
      <PictureImage status={status} backgroundSrc={src} historic={historic} />
      {status && (
        <CornerIcon>
          <StatusIcon status={status} />
        </CornerIcon>
      )}
    </PictureCover>
  );
};

export default ImageBox;
